<nav class="navbar" role="navigation" aria-label="main navigation" id="main-nav-bar-menu">
  <div class="navbar-brand">
    @if (!isAuthenticated) {
      <div class="navbar-item">
        <a class="button has-text-black has-background-white-ter" (click)="initiateLogin()">{{ 'button.login.label' | localize }}</a>
      </div>
      <div class="navbar-item">
        <app-language-selector/>
      </div>
    }
    <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicTop"
       (click)="toggleMenu()">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicTop" class="navbar-menu" [ngClass]="{'is-active': isMenuOpen}">
    @if (isAuthenticated) {
      <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
         routerLink="/dashboard">{{ 'menu.dashboard.label' | localize }}</a>
      <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
         routerLink="/claims-overview">{{ 'menu.overview.label' | localize }}</a>
      <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
         routerLink="/claims-search">{{ 'menu.search.label' | localize }}</a>
      @if (isAdjustor) {
        <div class="navbar-item is-size-6 has-dropdown" [ngClass]="{'is-active': isCreateClaimMenuOpen}"
             (click)="onClickCreateClaimMenuOpen()">
          <a class="navbar-link" [routerLinkActive]="['/claim/{{ObjectType.CondominiumUnit}}', '/claim/{{ObjectType.Residence}}']">
            {{ 'menu.createClaim.label' | localize }}
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
               routerLink="/claim/create/{{ObjectType.CondominiumUnit}}">
              {{ 'menu.createClaim.forCondominiumUnit.label' | localize }}
            </a>
            <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
               routerLink="/claim/create/{{ObjectType.Residence}}">
              {{ 'menu.createClaim.forSingleBuilding.label' | localize }}
            </a>
            <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
               routerLink="/claim/create/{{ObjectType.Others}}">
              {{ 'menu.createClaim.forOthers.label' | localize }}
            </a>
          </div>
        </div>
        <a class="navbar-item is-size-6" routerLinkActive="has-background-grey-lighter" (click)="toggleMenu()"
           routerLink="/claim/batch-upload">{{ 'menu.batchUpload.label' | localize }}</a>
      }
    }

    @if (isAuthenticated) {
      <div class="navbar-end">
        <div class="navbar-item">
          <app-year-selector/>
        </div>
        <div class="navbar-item">
          <app-language-selector/>
        </div>
        <div class="navbar-item has-text-link is-size-6">
            <span class="icon-text">
              <span class="icon">
                <i class="fas fa-user-circle"></i>
              </span>
              <span><a routerLink="/user/me"
                       routerLinkActive="has-background-grey-lighter">{{ getUsername() }}</a></span>
            </span>
        </div>
        <div class="buttons navbar-item is-size-6">
          <a class="button is-dark" (click)="triggerLogout()">{{ 'button.logout.label' | localize }}</a>
        </div>
      </div>
    }
  </div>
</nav>
